import styled from "styled-components";
import { COLORS, responsive } from "../../../../../styles/constants.style";

export const GenericAccountsSearchFormWrapper = styled.div`
  background-color: ${COLORS.cirrus_white};
  .form-header {
    padding-left: 16px;
    .form-header-left {
      line-height: 20px;
      color: ${COLORS.cirrus_black10};
    }
  }
  .form-container {
    padding: 0px 0px 16px 16px;
    ${responsive.MOBILE`
     padding: 0px 8px 0px 0px;
    `}
    .first-row {
      padding-top: 24px;
    }
  }
  .form-field {
    margin-top: 40px;
    ${responsive.MOBILE`
      margin-top:24px;
    `}
  }
  .button-container {
    justify-content: end;
    padding-bottom: 20px;
    gap: 16px;
    margin-right: 16px;
    margin-top: 40px;
    ${responsive.MOBILE`
      flex-direction:column-reverse;
      margin-top: 0;
      margin-right: 0;
      padding-bottom: 0px;
    `}
    button {
      ${responsive.MOBILE`
        width: 100%;
        margin: 16px 0px 0px;
      `}
    }
  }
  .padding-horizontal {
    ${responsive.MOBILE`
      margin: 0px 8px;
    `}
  }
  .MuiGrid2-root {
    padding-right: 16px;
    ${responsive.MOBILE`
      padding-right: 0px;
    `}
  }
  .MuiGrid2-container {
    padding-right: 0px;
    ${responsive.MOBILE`
      padding-left: 8px;
      padding-right: 8px;
    `}
  }

  .reset-all-button {
  }
`;
